module.exports = __webpack_public_path__ + "static/media/3.15_preview.d913aaed.png";